import { Dialog } from 'primereact/dialog';
import classes from './ParallelIterationModal.module.scss';
import ParallelIterationsTable from '../ParallelIterationsTable/ParallelIterationsTable';
import { Button } from 'primereact/button';
import useParallelIterations from './useParallelIteration';

const ParallelIterationsModal = ({
  visibility,
  toggleVisibility,
  conceptName,
  isGoToOpportunityButtonVisible,
  isCreateNewIterationButtonVisible,
  sourceId = 0,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
  conceptName: string;
  isGoToOpportunityButtonVisible?: boolean;
  isCreateNewIterationButtonVisible?: boolean;
  sourceId?: number;
}) => {
  const { createNewFreshIteration, isOpportunityAddLoading } = useParallelIterations({
    conceptName,
    toggleModalVisibility: toggleVisibility,
    sourceId,
  });

  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      headerClassName={classes.modalHeader}
      header={conceptName}
      visible={visibility}
      style={{
        width: '60vw',
      }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
    >
      {isCreateNewIterationButtonVisible && (
        <div className={classes.createNewIterationSection}>
          <Button
            className={classes.createNewIterationButton}
            onClick={createNewFreshIteration}
            loading={isOpportunityAddLoading}
          >
            <span>Create New Iteration</span>
          </Button>
          <span className={classes.createNewIterationInformation}>
            Creates new iteration without copying details from old iteration
          </span>
        </div>
      )}
      <ParallelIterationsTable
        conceptName={conceptName}
        showHeader={false}
        isCreateNewIterationButtonVisible={isCreateNewIterationButtonVisible}
        isGoToOpportunityButtonVisible={isGoToOpportunityButtonVisible}
        goToIterationCreateNewIterationCallBack={toggleVisibility}
      />
    </Dialog>
  );
};

export default ParallelIterationsModal;
